import { RouteConfig } from '../../routing/types'

const ROUTE: RouteConfig = {
  name: 'home',
  path: () => '/',
}

export default ROUTE
